import {
  topbarIconButtonAssistantClass,
  topbarIconButtonAssistantPrimaryClass,
  topbarIconButtonGhostClass,
  topbarSectionButtonBadgeClass,
  topbarSectionButtonClass,
} from './topbarClasses.js';

const TopbarIconButton = ({
  icon: Icon,
  onClick,
  ariaLabel,
  title,
  showNativeTitle = true,
  variant = 'ghost',
  size = 'default',
  showBadge = false,
  className = '',
}) => {
  const isSection = size === 'section';
  const baseClass =
    variant === 'assistant'
      ? topbarIconButtonAssistantClass
      : variant === 'assistantPrimary'
        ? topbarIconButtonAssistantPrimaryClass
        : isSection
          ? topbarSectionButtonClass
          : topbarIconButtonGhostClass;
  const iconSize = isSection ? 20 : 16;

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      title={showNativeTitle ? title || ariaLabel : undefined}
      className={[baseClass, className].filter(Boolean).join(' ')}
    >
      {Icon ? <Icon size={iconSize} aria-hidden /> : null}
      {showBadge ? (
        <span className={topbarSectionButtonBadgeClass} aria-label="Notifications" />
      ) : null}
    </button>
  );
};

export default TopbarIconButton;
